<template>
<form class="d-flex align-items-center flex-wrap flex-md-nowrap m-0 p-0" @submit.prevent="">
	<div class="d-flex flex-fill flex-nowrap px-md-2">
		<label class="mx-2" for="from-time">З:</label>
		<input
			type="datetime-local"
			name="from-time"
			ref="fromTime"
			@keyup.enter="apply()"
			:disabled="disabled"
		/>
	</div>

	<div class="d-flex flex-fill flex-nowrap px-md-2">
		<label class="mx-2" for="from-time">По:</label>
		<input
			type="datetime-local"
			name="from-time"
			ref="toTime"
			@keyup.enter="apply()"
			:disabled="disabled"
		/>
	</div>

	<div class="d-flex flex-fill flex-nowrap px-md-2">
		<button
			class="btn btn-sm btn-light"
			@click="apply()"
			:disabled="disabled"
		>
			Застосувати
		</button>
	</div>
</form>
</template>


<script>
import {
	subtractMinutesFromNowDate,
	subtractYearsFromNowDate,
	dateTimeLocalString,
} from '@/helpers.js'


export default {
	minutesFromNow: 15,

	props: {
		defaultFrom: {
			type: Date,
			required: false,
			default: subtractMinutesFromNowDate(15)
		},

		defaultTo: {
			type: Date,
			required: false,
			default: new Date(),
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false,
		}
	},

	emits: {
		from: value => value instanceof Date,
		to: value => value instanceof Date,
		// Returns fromTime, toTime
		submit: null,
	},

	data() {
		return {}
	},

	watch: {
		// defaultFrom() {
		// 	this.$refs.fromTime.value = dateTimeLocalString(this.defaultFrom)
		// },

		// defaultTo() {
		// 	this.$refs.toTime.value = dateTimeLocalString(this.defaultTo)
		// }
	},

	created() {
		this.$emit('from', this.defaultFrom)
		this.$emit('to', this.defaultTo)
	},

	mounted() {
		this.$refs.fromTime.min = dateTimeLocalString(subtractYearsFromNowDate(3))
		this.$refs.fromTime.max = dateTimeLocalString(new Date())
		this.$refs.fromTime.value = dateTimeLocalString(this.defaultFrom)

		this.$refs.toTime.min = dateTimeLocalString(subtractYearsFromNowDate(3))
		this.$refs.toTime.max = dateTimeLocalString(new Date())
		this.$refs.toTime.value = dateTimeLocalString(this.defaultTo)
	},

	methods: {
		// dtToLocalString(dt) {
		// 	return dateTimeLocalString(dt)
		// },

		apply() {
			const from = new Date(this.$refs.fromTime.value)
			const to = new Date(this.$refs.toTime.value)

			if (from >= to) {
				alert("Будь ласка, дотримуйтесь правила час \"З\" має буди до часу \"По\"!")
				return
			}
			
			this.$emit('from', from)
			this.$emit('to', to)

			this.$emit('submit', from, to)
		},
	},
}
</script>

